import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PostSignInComponent } from './pages/post-sign-in/post-sign-in.component';
import { PostSignOutComponent } from './pages/post-sign-out/post-sign-out.component';
import { RestrictedGuard } from './guards/restricted.guard';
import { UnrestrictedGuard } from './guards/unrestricted.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'home', component: HomeComponent, canActivate: [UnrestrictedGuard] },
  { path: 'post-sign-in', component: PostSignInComponent },
  { path: 'post-sign-out', component: PostSignOutComponent },
  {
    path: 'template-list',
    canActivate: [RestrictedGuard],
    loadChildren: () => import('./pages/template-list/template-list.routes').then(m => m.templateListRoutes)
  },
  {
    path: 'edit-template',
    canActivate: [RestrictedGuard],
    loadChildren: () => import('./pages/edit-template/edit-template.routes').then(m => m.editTemplateRoutes)
  },
  {
    path: 'analytics',
    canActivate: [RestrictedGuard],
    loadChildren: () => import('./pages/analytics/analytics.routes').then(m => m.analyticsRoutes)
  },
  {
    path: 'cli-access',
    canActivate: [RestrictedGuard],
    loadChildren: () => import('./pages/cli-access/cli-access.routes').then(m => m.cliAccessRoutes)
  },
  { path: '**', redirectTo: '/template-list' }
];
